import { jsxs as _, jsx as o } from "react/jsx-runtime";
import { b4 as h, d as n } from "../../vendor-Dd6qj6gJ.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as p } from "../../utils/omitStyleRenderProps/index.js";
import { FieldDescription as x } from "../FieldDescription/index.js";
import { FieldError as u } from "../FieldError/index.js";
import { FieldLabel as b } from "../FieldLabel/index.js";
import { TextArea as F } from "../TextArea/index.js";
import '../../assets/index59.css';const j = "_textAreaField_1i8ji_1", z = "_fieldControl_1i8ji_15", C = "_autoResizeControl_1i8ji_22", A = "_label_1i8ji_26", R = "_horizontal_1i8ji_30", N = "_fullWidth_1i8ji_49", e = {
  textAreaField: j,
  fieldControl: z,
  autoResizeControl: C,
  label: A,
  horizontal: R,
  fullWidth: N
};
function T({ autoResize: t, fullWidth: i }) {
  return t ? "none" : i ? "vertical" : "both";
}
function g({
  label: t,
  description: i,
  errorMessage: s,
  rows: d = 3,
  autoResize: l = !1,
  maxRows: c,
  resize: f,
  fullWidth: r = !1,
  horizontal: m = !1,
  ...a
}) {
  return /* @__PURE__ */ _(
    h,
    {
      ...p(a),
      className: n(e.textAreaField, {
        [e.fullWidth]: r,
        [e.horizontal]: m
      }),
      "data-component": "TextAreaField",
      children: [
        /* @__PURE__ */ o(b, { className: e.label, children: t }),
        /* @__PURE__ */ o(
          F,
          {
            "aria-label": a["aria-label"],
            rows: d,
            autoResize: l,
            maxRows: c,
            resize: f ?? T({ autoResize: l, fullWidth: r }),
            className: n(e.fieldControl, { [e.autoResizeControl]: l })
          }
        ),
        /* @__PURE__ */ o(x, { children: i }),
        /* @__PURE__ */ o(u, { children: s })
      ]
    }
  );
}
export {
  g as TextAreaField
};
